import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Line } from "@antv/g2plot";
import chartMixin from "../mixin/chartMixin";
export default {
  name: "NewUserChart",
  mixins: [chartMixin],
  data: function data() {
    return {
      city: []
    };
  },
  props: {
    cityList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    getData: function getData(type, city) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var param;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              param = {
                chartName: "ads_house_new_house_chart",
                grain: _this.communityGrain,
                groupBy: type,
                start: _this.dateTime[0],
                end: _this.dateTime[1],
                valueName: "num"
              };
              if (city) {
                param.city = city;
              }
              return _context.a(2, new Promise(function (resolve, reject) {
                _this.$api.getPostChartData(param).then(function (res) {
                  var data = res.data.map(function (i) {
                    return _objectSpread(_objectSpread({}, i), {}, {
                      city: type ? i.city : "全部"
                    });
                  });
                  resolve(data);
                }).catch(function (err) {
                  reject([]);
                });
              }));
          }
        }, _callee);
      }))();
    },
    getPostChartData: function getPostChartData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this2$city;
        var cites;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              cites = _this2.city.length ? (_this2$city = _this2.city) === null || _this2$city === void 0 || (_this2$city = _this2$city.map(function (city) {
                return city.replace(/\s+/g, '');
              })) === null || _this2$city === void 0 || (_this2$city = _this2$city.join(',')) === null || _this2$city === void 0 ? void 0 : _this2$city.toLocaleLowerCase() : '';
              return _context2.a(2, Promise.all([_this2.getData(cites ? 'city' : '', cites)]).then(function (res) {
                if (res.length) {
                  return res.flat(2);
                }
                return [];
              }));
          }
        }, _callee2);
      }))();
    },
    init: function init() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this3.loading = true;
              _context3.n = 1;
              return _this3.getPostChartData();
            case 1:
              data = _context3.v;
              _this3.loading = false;
              if (_this3.lineChart) {
                _this3.lineChart.changeData(data);
              } else {
                _this3.lineChart = new Line("newHouseChart", {
                  data: data,
                  xField: "time",
                  yField: "num",
                  seriesField: "city",
                  legend: {
                    position: "top",
                    offsetY: 70
                  },
                  smooth: true,
                  appendPadding: [70, 0, 0, 0]
                });
                _this3.lineChart.render();
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    command: function command(type) {
      this.communityGrain = type;
      this.init();
    }
  }
};